import { ScheduleSlot } from '../../../../../core/components/organism/ScheduleSlot';

interface IDisciplineScheduleSlotProps {
  disciplineSlug: string;
  compact?: boolean;
  selected?: boolean;
  currentProgress: number;
  totalProgress: number;
  className?: string;
  title?: string;
  type?: 'summary' | 'default';
  exercisesSolved?: number;
  lessonsWatched?: number;
  materialsSeen?: number;
  onClick?: () => void;
}

export function DisciplineScheduleSlot({
  disciplineSlug,
  compact = false,
  selected = false,
  currentProgress,
  totalProgress,
  className,
  type = 'default',
  title,
  exercisesSolved,
  lessonsWatched,
  materialsSeen,
  onClick,
}: IDisciplineScheduleSlotProps) {
  function getProgressPercentage() {
    return (currentProgress / totalProgress) * 100;
  }

  return (
    <ScheduleSlot.Root
      disciplineSlug={disciplineSlug}
      compact={compact}
      selected={selected}
      currentProgress={currentProgress}
      totalProgress={totalProgress}
      className={className}
      type={type}
      onClick={onClick}
    >
      {compact && type === 'default' ? (
        <ScheduleSlot.Compact type='discipline' title={title}/>
      ) : (
        <>
          <ScheduleSlot.Header
            type='discipline'
            progressText={`${getProgressPercentage().toFixed(0)}% concluída`}
            finished={currentProgress === totalProgress}
          />
          <ScheduleSlot.Progress
            progressType='time'
            type='discipline'
            progressBarColor={`disciplina-${disciplineSlug}`}
          />
          {type === 'summary' && (
            <ScheduleSlot.ContentSummary
              exercisesSolved={exercisesSolved}
              lessonsWatched={lessonsWatched}
              materialsSeen={materialsSeen}
            />
          )}
        </>
      )}
    </ScheduleSlot.Root>
  );
}
